import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";
import Select from "react-select";

export const CrearJornadaManualGerente = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [centros, setCentros] = useState([]);

  const [usuarioId, setUsuarioId] = useState("");
  const [centroId, setCentroId] = useState("");
  const [inicio, setInicio] = useState("");
  const [fin, setFin] = useState("");
  const [comentario, setComentario] = useState("");
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const res = await fetch(`${Global.url}usuarios`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (res.ok) {
          setUsuarios(await res.json());
        }
      } catch (err) {
        console.error("Error al obtener usuarios:", err);
      }
    };

    const fetchCentros = async () => {
      try {
        const res = await fetch(`${Global.url}centros`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (res.ok) {
          setCentros(await res.json());
        }
      } catch (err) {
        console.error("Error al obtener centros:", err);
      }
    };

    fetchUsuarios();
    fetchCentros();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!usuarioId || !centroId || !inicio || !fin) {
      setMensaje("Todos los campos son obligatorios.");
      return;
    }

    const payload = {
      usuario_id: parseInt(usuarioId),
      centro_id: parseInt(centroId),
      inicio,
      fin,
      observaciones_admin: comentario,
    };

    try {
      const res = await fetch(`${Global.url}jornadas/manual`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setMensaje("✅ Jornada creada correctamente.");
        setUsuarioId("");
        setCentroId("");
        setInicio("");
        setFin("");
        setComentario("");
      } else {
        const errorData = await res.json();
        setMensaje(`❌ Error: ${errorData.message || "No se pudo crear la jornada."}`);
      }
    } catch (error) {
      console.error("Error al crear jornada:", error);
      setMensaje("❌ Error al conectar con el servidor.");
    }
  };

  // Opciones react-select
  const usuarioOptions = usuarios.map((u) => ({
    value: u.id,
    label: `${u.nombre} ${u.apellidos || ""}`,
  }));
  const centroOptions = centros.map((c) => ({
    value: c.id,
    label: c.nombre,
  }));

  const valueFrom = (options, value) =>
    options.find((opt) => String(opt.value) === String(value)) || null;

  return (
    <div className="form-jornada-wrapper">
      <h2 className="centrar-titulo">Crear Jornada Manual (Gerente)</h2>
      {mensaje && <p className="confirmacion">{mensaje}</p>}

      <form className="form-jornada-manual" onSubmit={handleSubmit}>
        <label>Usuario:</label>
        <Select
          options={usuarioOptions}
          value={valueFrom(usuarioOptions, usuarioId)}
          onChange={(opt) => setUsuarioId(opt?.value || "")}
          isClearable
          className="select-usuario rs-full"
          classNamePrefix="select"
          placeholder="Selecciona un usuario"
        />

        <label>Centro:</label>
        <Select
          options={centroOptions}
          value={valueFrom(centroOptions, centroId)}
          onChange={(opt) => setCentroId(opt?.value || "")}
          isClearable
          className="select-centro rs-full"
          classNamePrefix="select"
          placeholder="Selecciona un centro"
        />

        <label>Inicio:</label>
        <input
          className="input-layout"
          type="datetime-local"
          value={inicio}
          onChange={(e) => setInicio(e.target.value)}
          required
        />

        <label>Fin:</label>
        <input
          className="input-layout"
          type="datetime-local"
          value={fin}
          onChange={(e) => setFin(e.target.value)}
          required
        />

        <label>Motivo o comentario:</label>
        <textarea
          className="input-layout"
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
          placeholder="Explica por qué se crea esta jornada manualmente"
          rows={3}
        />

        <button type="submit" className="btn-login">
          Crear jornada
        </button>
      </form>
    </div>
  );
};
